import { useState } from "react";
import "./CrunchTimeBar.scss";
import CrunchTimeLabel from "./CrunchTimeLabel/CrunchTimeLabel";

export default function CrunchTimeBar(props) {
  return (
    <div className="crunch-time-bar-container">
      <div className="crunch-time-bar"></div>
      <CrunchTimeLabel></CrunchTimeLabel>
    </div>
  );
}
